/**
 * Created by eriksundqvist on 12/10/16.
 */
/**
 * Created by eriksundqvist on 12/10/16.
 */
import { connect } from 'react-redux';
import AddCoworker from './add-coworker';

function mapStateToProps (state) {
  return {
    invoice: state.invoice
  };
};

export default connect(mapStateToProps)(AddCoworker);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/add-coworker-container.js
 **/